import { useState,useEffect } from "react";
import api from '../../axios';

const RoleManagementModal = ({ isOpen, onClose }) => {
  const [roles, setRoles] = useState([]);
  const [newRole, setNewRole] = useState("");
  const [editingRole, setEditingRole] = useState(null);

  // Fetch roles from the backend
  useEffect(() => {
    if (isOpen) {
      fetchRoles();
    }
  }, [isOpen]);

  const fetchRoles = async () => {
    try {
      const response = await api.get("/roles");
      setRoles(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  // Add a new role
  const addRole = async () => {
    if (newRole.trim() === "") return;

    try {
      const response = await api.post("/roles", { name: newRole });
      setRoles([...roles, response.data]);
      setNewRole("");
    } catch (error) {
      console.error("Error adding role:", error);
    }
  };

  // Update an existing role
  const updateRole = async () => {
    if (!editingRole) return;

    try {
      const response = await api.put(`/roles/${editingRole.id}`, { name: newRole });
      setRoles(
        roles.map((role) => (role.id === editingRole.id ? response.data : role))
      );
      setEditingRole(null);
      setNewRole("");
    } catch (error) {
      console.error("Error updating role:", error);
    }
  };

  // Delete a role
  const deleteRole = async (id) => {
    try {
      await api.delete(`/roles/${id}`);
      setRoles(roles.filter((role) => role.id !== id));
    } catch (error) {
      console.error("Error deleting role:", error);
    }
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
          <h2 className="text-xl font-semibold mb-4">Manage Roles</h2>

          {/* Role Input */}
          <div className="flex space-x-2 mb-4">
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Enter role name"
              value={newRole}
              onChange={(e) => setNewRole(e.target.value)}
            />
            {editingRole ? (
              <button
                className="px-4 py-2 bg-green-600 text-white rounded-md"
                onClick={updateRole}
              >
                Update
              </button>
            ) : (
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md"
                onClick={addRole}
              >
                Add
              </button>
            )}
          </div>

          {/* Role List */}
          <ul className="space-y-2 max-h-40 overflow-y-auto">
            {roles.map((role) => (
              <li
                key={role.id}
                className="flex justify-between items-center p-2 border rounded-md"
              >
                <span>{role.name}</span>
                <div className="flex space-x-2">
                  <button
                    className="px-2 py-1 bg-yellow-500 text-white text-sm rounded-md"
                    onClick={() => {
                      setEditingRole(role);
                      setNewRole(role.name);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="px-2 py-1 bg-red-600 text-white text-sm rounded-md"
                    onClick={() => deleteRole(role.id)}
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3 pt-4">
            <button
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default RoleManagementModal;
